export const useHarmonyLink = (link: string): void => {
  const tagA = document.createElement('a');
  tagA.style.display = 'none';
  document.body.appendChild(tagA);
  tagA.setAttribute('href', link);
  tagA.click();
};
